import React from 'react';
import Relay from 'react-relay';

import TodoTextInput from './TodoTextInput';

export default class TodoApp extends React.Component {
  static propTypes = {
    viewer: React.PropTypes.object.isRequired,
    children: React.PropTypes.node.isRequired
  };

  onNewTodoSave = (text) => {};

  render() {
    const { children } = this.props;

    return (
      <div data-framework="relay">
          {children}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/TodoApp.js
 **/